import { useIntl } from 'react-intl';
import {
  GetMessageWithIntl,
  MessageProps,
} from '~/shared/components/parts/Message/Message';
import {
  ModalDialogComponent,
  ModalDialogComponentProps,
} from '../ModalDialog/ModalDialog';
import { CaptionButton } from '~/shared/components/ui/Button/CaptionButton';
import './base.css';

export interface CompanyNumberWarningDialogMessageOption {
  headerLabelId: MessageProps;
  messageLabelId?: MessageProps;
}

export interface CompanyNumberWarningDialogProps {
  isOpen: boolean;
  messageOption: CompanyNumberWarningDialogMessageOption;
  onDecision: () => void;
  onCancel: () => void;
}

export function CompanyNumberWarningDialog(
  props: CompanyNumberWarningDialogProps
) {
  const intl = useIntl();

  const { isOpen, messageOption, onCancel, onDecision } = props;

  const handleCancel = () => {
    onCancel();
  };

  const handleDecision = () => {
    onDecision();
  };

  const view = (
    <div className="company-number-warning-dialog dialog-with-description">
      <div className="message">
        {GetMessageWithIntl(intl, { id: 'W0000017' })}
      </div>
      <div className="button-area">
        <CaptionButton
          name="backBtn"
          buttonType="high"
          className="button"
          caption={GetMessageWithIntl(intl, {
            prefixId: 'COMPANY_NUMBER_WARNING_DIALOG',
            id: 'back',
          })}
          onClick={() => handleCancel()}
        />
        <CaptionButton
          name="proceedBtn"
          buttonType="cancel"
          className="button"
          caption={GetMessageWithIntl(intl, {
            prefixId: 'COMPANY_NUMBER_WARNING_DIALOG',
            id: 'proceed',
          })}
          onClick={() => handleDecision()}
        />
      </div>
    </div>
  );

  const openModalProps: ModalDialogComponentProps = {
    cancel: () => {
      handleCancel();
    },
    send: () => {},
    modalIsOpen: isOpen,
    headerLabelId: messageOption.headerLabelId,
    messageLabelId: messageOption.messageLabelId ?? {},
    elements: view,
  };

  return <ModalDialogComponent {...openModalProps} />;
}
